import * as Styles from './styles';
import toTestId from '../../../v2/utils/toTestId';
//import { useTranslation } from 'react-i18next';
import { IconButton, IconClose } from 'cdk-radial';

interface Props {
    learnMoreData: {
        description?: string;
        name?: string;
        iconText?: string;
        iconColor?: string;
    },
    isOpen?: boolean;
    onClose?: Function
}

export default function LearnMoreDialog( { learnMoreData, isOpen, onClose }: Props) {
  //const {t} = useTranslation();
  const { name, iconColor, iconText, description } = learnMoreData;
  return (
    <Styles.LearnMoreDialog 
        id="learn-more-dialog"
        title=""
        isOpen={isOpen} 
        onClose={ onClose }
        hideHeader 
        disableOverlayClicked={false}>

        <Styles.LearnMoreCard
            data-testid={`more-card-${toTestId(name || '')}`}>
        <div>
            <Styles.CardHeader>
                <Styles.ProductIcon iconColor={iconColor || ''} data-testid="app-icon">
                {iconText || ''}
                </Styles.ProductIcon>
                <Styles.CardTitle>
                    {name}
                    <Styles.DialogCloseButton>
                        <IconButton icon={<IconClose />} onClick={onClose} data-testid="close-button" text=''/>
                    </Styles.DialogCloseButton>
                </Styles.CardTitle>
            </Styles.CardHeader>
            <Styles.LearMoreDescription><Styles.LearMoreDevider data-testid="divider" />{description}</Styles.LearMoreDescription> 
        </div>
        </Styles.LearnMoreCard>
    </Styles.LearnMoreDialog>
  );
}
